import React from 'react';
import { useTopPosts } from '@hooks/useTopPosts';
import { TopPost, TopPostSkeleton } from './TopPost';

export const TopPosts = () => {
  const { topPosts, isLoading } = useTopPosts();

  if (isLoading)
    return (
      <div className="flex flex-col gap-4">
        <span className="font-title text-title-s font-medium">Top Posts</span>
        <div className="flex flex-col gap-8">
          <TopPostSkeleton />
          <TopPostSkeleton />
          <TopPostSkeleton />
          <TopPostSkeleton />
        </div>
      </div>
    );

  if (!topPosts.length) return null;

  return (
    <div className="flex flex-col gap-4">
      <span className="font-title text-title-s font-medium">Top Posts</span>
      <div className="flex flex-col gap-8">
        {topPosts.map(item => (
          <TopPost key={item.id} postFrag={item} />
        ))}
      </div>
    </div>
  );
};
